// extracted by mini-css-extract-plugin
module.exports = {"deleteButton":"EditReleaseProfileModalContent-deleteButton-2Y2PQ Button-button-2PYOE Link-link-1rgM9"};